/**
 * Resolves once bootDemo() has installed the demo store and mocks. Anything the app fires while
 * its modules are still evaluating (e.g. the banner fetch in redux/boot.js) waits for it, so no
 * request reaches a real backend before the mocks exist. Tiny on purpose: statically imported.
 */
let markReady: () => void = () => {};

export const demoReady: Promise<void> = new Promise((resolve) => {
  markReady = resolve;
});

export const signalDemoReady = (): void => markReady();

type LoadDemo = () => Promise<{ bootDemo: () => void }>;

/** Called by src/index.jsx before the first render; loads the demo on demand. */
export const startDemo = async (loadDemo: LoadDemo = () => import('demo')): Promise<void> => {
  try {
    const { bootDemo } = await loadDemo();
    bootDemo();
  } catch (error) {
    console.error('Demo boot failed', error);
    // E.g. a redeploy replaced the hashed demo chunk under a cached page. Release held requests
    // so the page fails visibly instead of loading forever; demo builds point every backend URL
    // at a same-origin dummy path, so nothing reaches a real API.
    signalDemoReady();
  }
};
